import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../../../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [menus, setMenus] = useState([]);
    const [loading, setLoading] = useState(true);

    // Cek sessionStorage saat mount
    useEffect(() => {
        const token = sessionStorage.getItem('adminToken');
        const savedUser = sessionStorage.getItem('adminUser');
        const savedMenus = sessionStorage.getItem('adminMenus');
        if (token && savedUser) {
            setUser(JSON.parse(savedUser));
            if (savedMenus) setMenus(JSON.parse(savedMenus));
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        try {
            const response = await api.post('/login', { email, password });
            const { token, user, menus } = response.data;

            // Simpan ke sessionStorage
            sessionStorage.setItem('adminToken', token);
            sessionStorage.setItem('adminUser', JSON.stringify(user));
            sessionStorage.setItem('adminMenus', JSON.stringify(menus));

            // Update state
            setUser(user);
            setMenus(menus);

            return { success: true };
        } catch (error) {
            let message = 'Terjadi kesalahan, silakan coba lagi';
            if (error.response) {
                message = error.response.data.message || message;
            }
            return { success: false, message };
        }
    };

    const logout = async () => {
        try {
            await api.post('/logout');
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            sessionStorage.removeItem('adminToken');
            sessionStorage.removeItem('adminUser');
            sessionStorage.removeItem('adminMenus');
            setUser(null);
            setMenus([]);
        }
    };

    const value = {
        user,
        menus,
        login,
        logout,
        loading,
        isAuthenticated: !!user,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};